import { toast } from "sonner";
import { useSettings } from "@/context/SettingsContext";
import { BlurInput, Pick, Row, Section, Toggle } from "@/components/settings/Controls";

const DIGEST = [{ value: "3h", label: "Every 3 hours" }, { value: "daily", label: "Daily at 9am" }, { value: "off", label: "Never" }];
const PRIORITIES = [{ value: "high", label: "High (every 15 min)" }, { value: "medium", label: "Medium (hourly)" }, { value: "low", label: "Low (every 4 hours)" }, { value: "custom", label: "Custom" }];

export const NotificationsTab = () => {
  const { prefs, savePrefs, team, saveTeam } = useSettings();
  const browser = async (v) => {
    if (v && "Notification" in window && Notification.permission === "default") await Notification.requestPermission();
    savePrefs({ browser_alerts: v });
  };
  return (
    <div className="space-y-6">
      <Section title="Your alerts" hint="These only affect you. Support always gets its copy." testid="settings-alerts">
        <Toggle label="Email me when my reminders fire" checked={prefs.email_alerts} onChange={(v) => savePrefs({ email_alerts: v })} testid="pref-email-alerts" />
        <Toggle label="Browser pop-up alerts" hint="Desktop notifications while the dashboard is open." checked={prefs.browser_alerts} onChange={browser} testid="pref-browser-alerts" />
        <Row label="Quiet hours" hint="No emails to you between these times (UK time).">
          <BlurInput type="time" value={prefs.quiet_start} onSave={(v) => savePrefs({ quiet_start: v })} className="w-32 font-mono" testid="pref-quiet-start" />
          <span className="text-muted-foreground">to</span>
          <BlurInput type="time" value={prefs.quiet_end} onSave={(v) => savePrefs({ quiet_end: v })} className="w-32 font-mono" testid="pref-quiet-end" />
        </Row>
        <Toggle label="Weekend mode" hint="No emails to you on Saturday or Sunday." checked={prefs.weekend_mode} onChange={(v) => savePrefs({ weekend_mode: v })} testid="pref-weekend-mode" />
      </Section>
      {team && (
        <Section title="Team digest" hint="The summary of everyone's open reminders sent to support." testid="settings-digest">
          <Row label="Send the digest"><Pick value={team.notifications.digest} onChange={(digest) => saveTeam({ notifications: { digest } }, "Digest schedule saved")} options={DIGEST} testid="team-digest-select" /></Row>
        </Section>
      )}
    </div>
  );
};

export const RemindersTab = () => {
  const { team, saveTeam } = useSettings();
  if (!team) return null;
  const r = team.reminders;
  return (
    <Section title="Reminder defaults" hint="Applies to everyone." testid="settings-reminders">
      <Row label="Default priority for new reminders"><Pick value={r.default_priority} onChange={(v) => saveTeam({ reminders: { default_priority: v } }, "Saved")} options={PRIORITIES} testid="team-default-priority" className="w-56" /></Row>
      <Row label="Count as overdue after" hint="How long a high-priority reminder can keep emailing before the wallboard shouts about it.">
        <BlurInput type="number" min={5} value={r.overdue_minutes} onSave={(v) => (Number(v) >= 5 ? saveTeam({ reminders: { overdue_minutes: Number(v) } }, "Saved") : toast.error("At least 5 minutes"))} className="w-24 font-mono" testid="team-overdue-minutes" />
        <span className="text-sm text-muted-foreground">minutes</span>
      </Row>
    </Section>
  );
};
